<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <div id="nav">
      <b-navbar toggleable="lg" type="dark" variant="dark">
        <b-navbar-brand href="/#/">larsbutler.net</b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav>
            <b-nav-item href="/#/">Home</b-nav-item>
            <b-nav-item-dropdown text="D&D" right>
              <b-dropdown-item href="/#/dnd/character-sheet">Character Sheet (5e)</b-dropdown-item>
              <b-dropdown-item href="/#/dnd/ogl">Open Game License</b-dropdown-item>
            </b-nav-item-dropdown>
          </b-navbar-nav>

          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto">
            <!-- <b-nav-item href="/#/">{{ loginText }}</b-nav-item> -->
            <b-nav-item v-if="!isUserLoggedIn()" v-bind:href="loginUrl()">Login</b-nav-item>
            <b-nav-item-dropdown v-if="isUserLoggedIn()" v-bind:text="getLoggedInUserEmail()" right>
              <b-dropdown-item v-bind:href="logoutUrl()">Logout</b-dropdown-item>
              <!-- Using 'button-content' slot -->
              <!-- <template slot="button-content"><em>User</em></template> -->
              <!-- <b-dropdown-item href="#" style="text-align: center"> -->
                <!-- <div class="g-signin2" data-onsuccess="onSignIn"></div> -->
              <!-- </b-dropdown-item> -->
              <!-- <b-dropdown-item href="#">Sign Out</b-dropdown-item> -->
            </b-nav-item-dropdown>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </div>

    <!-- This is what allows other components to be loaded, depending on the
        URL path. See `router/index.js`.
    -->
    <router-view/>
  </div>
</template>

<script>
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import { getIdToken, getLoggedInUserEmail } from '@/TokenUtils.ts'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'bootstrap/dist/css/bootstrap.css'

Vue.use(BootstrapVue)
export default {
  name: 'App',
  methods: {
    getLoggedInUserEmail: function () {
      return getLoggedInUserEmail()
    },
    isUserLoggedIn: function () {
      return getIdToken() !== null
    },
    loginUrl: function () {
      let baseUrl = process.env.LOGIN_URL
      let clientId = process.env.COGNITO_USER_POOL_CLIENT_ID
      let scope = 'aws.cognito.signin.user.admin+email+openid+profile'
      let redirectUri = `${window.location.origin}/login/callback`
      let url = `${baseUrl}?client_id=${clientId}&response_type=token&scope=${scope}&redirect_uri=${redirectUri}`
      return url
    },
    logoutUrl: function () {
      let baseUrl = process.env.LOGOUT_URL
      let clientId = process.env.COGNITO_USER_POOL_CLIENT_ID
      let logoutUri = `${window.location.origin}/logout/callback`
      let url = `${baseUrl}?client_id=${clientId}&logout_uri=${logoutUri}`
      return url
    }
  },
  data: function () {
    return {}
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue